import React, { useEffect, useState } from "react";
import request from "../../../Helpers/API";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
//import ModalAgregarLineasScorecard from './ModalAgregarLineasScorecard';
import { LoaderScreen } from "../../components/LoaderScreen";
// import { FiltroPlantillasKarbot } from "./FiltroPlantillaKarbot";
// import { GetMonthName } from "../../helpers/GetMonthName";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { Checkbox } from "@mui/material";
import Button from "@mui/material/Button";
import RefreshIcon from "@mui/icons-material/Refresh";
// import { ModalGuardarTelefono } from "./ModalGuardarTelefono";

export const OperacionesNoEncontradasEquipScreen = () => {
  const history = useHistory();
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  const [openModal, setOpenModal] = useState(false);

  const [data, setData] = useState([]);

  useEffect(() => {
    onActualizar();
  }, []);
  const onActualizar = () => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`OperacionesNoEncontradasEquip/ListadoOperaciones`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setData(result);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
      });
  };
  const totalOperaciones = data.length;

  return (
    <PlantillaScreen
      titulo={"DOCUMENTO NO ENCONTRADO EN EQUIP"}
      className_main={1}
      className={"operaciones-no-encontradas-main-screen"}
    >
      <LoaderScreen loader={loader} />
      <div className="operaciones-no-encontradas-actions">
        <div
          className="operaciones-no-encontradas-actions-regresar"
          onClick={() => history.goBack()}
        >
          <ArrowBackIcon /> Regresar
        </div>

        <div
          className="operaciones-no-encontradas-actions-actualizar"
          onClick={() => onActualizar()}
        >
          <RefreshIcon /> Actualizar
        </div>
        {/* <FiltroPlantillasKarbot onExecute={onExecute} /> */}
      </div>
      <div className="operaciones-no-encontradas-numero-clientes">
        {`Se encontraron ${totalOperaciones} operaciones`}
      </div>
      {/* {data === undefined || data === null || data.length === 0 ? (
                <div></div>
            ) : ( */}
      <div className="operaciones-no-encontradas-table scroll-4">
        <table cellPadding={0} cellSpacing={0}>
          <thead>
            <tr>
              <th>
                <div>Folio</div>
              </th>
              <th>
                <div>Razón Social</div>
              </th>
              <th>
                <div>Vendedor</div>
              </th>
              <th>
                <div>Documento</div>
              </th>
              <th>
                <div>Importe</div>
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((item) => (
              <tr>
                <td>{item.folio}</td>
                <td>{item.razon_social}</td>
                <td>{item.empleado}</td>
                <td>{item.documento}</td>
                <td>{FormatMoney(item.importe)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </PlantillaScreen>
  );
};
